module.exports = __webpack_public_path__ + "img/logo.a92fd2eb.png";